import script from "./LoginFormAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginFormAdmin.vue?vue&type=script&setup=true&lang=js"

import "./LoginFormAdmin.vue?vue&type=style&index=0&id=1639e33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1639e33a"]])

export default __exports__